/*
 * Copyright (c) 2023-2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

export class GMNetlistCompareResultsHolder {
  harness1Set = new Array<string>;
  harness2Set = new Array<string>;
  harnessOverlapSet = new Array<string>;
  resultCodeSet = new Array<string>;
  compareResultsWB_File: string;
  constructor() {
  }
}
